/**
 * Ключ метки «кабинет открыт на кассе с нашей ОС» (D-40): кука от сервера
 * (`server/middleware/skup-os.ts`) и хранилище браузера (`plugins/skup-os.client.ts`)
 */
export const SKUP_OS_KEY = 'skup-os'
